import PropTypes from "prop-types";

import { tagular } from "@cohesion/tagular";

import { ImgixNextImage as Image } from "@components/imgixNextImage";

export function ArticleCard({
  slug = "",
  title = "",
  featuredImage = {},
  tags = [],
}) {
  return (
    <a
      href={slug}
      className="flex items-center"
      onClick={() => {
        tagular("click", {
          actionOutcome: "INTERNALLINK",
          outboundUrl: slug,
          webElement: {
            location: "BIT_PlanYourTrip",
            elementType: "LINK",
            position: "ARTICLE",
            text: title,
          },
        });
      }}
    >
      <div className="flex-none overflow-hidden rounded w-28 h-28 bg-black-100">
        <Image
          src={featuredImage.url}
          width={128}
          height={128}
          imgixParams={{ w: 128, h: 128, fit: "crop", ar: "1:1" }}
        />
      </div>
      <div className="ml-2">
        <p className="mb-2 text-sm font-bold">
          {Array.isArray(tags) && tags.length > 0
            ? tags[0]?.title || "Travel stories"
            : "Travel stories"}
        </p>
        <h4 className="text-lg font-bold leading-tight line-clamp-3">
          {title}
        </h4>
      </div>
    </a>
  );
}

ArticleCard.propTypes = {
  slug: PropTypes.string,
  title: PropTypes.string,
  featuredImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
};
